import { applyMiddleware, createStore } from 'redux';

import createSagaMiddleware from 'redux-saga';

import reducers from './reducers';

import mySaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(reducers, applyMiddleware(sagaMiddleware));

sagaMiddleware.run(mySaga);

export default store;
